import type { RootState } from "@/app/store";

export const selectSafehouseUntil = (state: RootState) =>
  state.safehouse.safeUntil;

export const selectNextSafehouseTime = (state: RootState) =>
  state.safehouse.nextSafehouseTime;

export const selectSafehouseDuration = (state: RootState) =>
  state.safehouse.duration;
